import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { Observable } from "rxjs";

// The files keep the same URL across deploys, so the browser must not reuse a copy
// older than the code that reads it.
const NO_CACHE = new HttpHeaders({ "Cache-Control": "no-cache", Pragma: "no-cache" });

@Injectable({ providedIn: "root" })
export class TranslocoHttpLoader implements TranslocoLoader {
    constructor(private http: HttpClient) {}

    getTranslation(lang: string): Observable<Translation> {
        const normalizedLang = lang.startsWith("/") ? lang.substring(1) : lang;

        return this.http.get<Translation>(
            `/assets/i18n/${normalizedLang}.json`,
            { headers: NO_CACHE },
        );
    }
}
